import { useState, useEffect, useCallback } from "react";
import { endpoint } from '../../views/pages/manage/common/constant';
import { fetchAllPromisedData } from 'views/pages/manage/common/utils/methods/commonMethods/utilityMethod';
import moment from "moment";
import { fetchAllPostPromisedData } from "views/pages/manage/common/utils/methods/commonMethods/utilityMethod";
import { documentServiceBaseUrl } from "services/http";
import { getCreateReceiptTemplateData, getLabelByValue, transferReasonDesc, transferTypeDesc } from "./constant";
import { transferReasonDropdown } from "modules/studentTransfer/components/utils";

export const getTransferDetails = async (psid, requestId, appId) => {
  const p = await Promise.all([fetchAllPromisedData(`${endpoint.studentDetails.getStudentPersonalInfo}/${psid}`),
  fetchAllPromisedData(`${endpoint.studentDetails.getStudentAddressByPsid}/${psid}`),
  fetchAllPromisedData(`${endpoint.studentTransfer.search}/${requestId}`),
  ])

  return {
    details: {
      ...p[0],
      ...p[1],
      ...p[2]?.transferInDetails,
      studentName: `${p[0]?.studentFirstName ?? ""} ${p[0]?.studentLastName ?? ""}`.trim(),
      studentAddress: `${p[1]?.addressLine1 ?? ""} ${p[1]?.addressLine2 ?? ""}`.trim(),
      appId,
      phoneNumber: p[0]?.primaryMobileNumber,
      effectiveDate: p[2]?.transferInDetails.effectiveDate ? moment(p[2]?.transferInDetails.effectiveDate).format('MMM DD, YYYY') : null,
      minReceiptDate: p[2]?.transferInDetails.minReceiptDate ? moment(p[2]?.transferInDetails.minReceiptDate).format('MMM DD, YYYY') : null,
      psid,
      transferType: transferTypeDesc?.[p[2]?.transferInDetails?.transferType] || p[2]?.transferInDetails?.transferType,
      transferReason:transferReasonDesc?.[p[2]?.transferInDetails?.transferReason]||p[2]?.transferInDetails?.transferReason
    },
    logs: p[2]?.logs
  }

}
export const getUploadUrl = async ({ fileName = 'transferCertificate.pdf', serviceName = "TRANSFER_REQUEST" }) => {
  const formData = {
    bulk: false,
    fileName: fileName,
    docType: "pdf",
    sourceId: 1,
    keyValue: new Date(),
    serviceName: serviceName,
  };

  const response = await fetchAllPostPromisedData(
    `${documentServiceBaseUrl}/documentManagement/getUploadUrl`,
    formData,
    "post"
  );

  if (response?.code == 200) return response.data;
  return null;
};

export const getUploadCertificateS3Key = async ({
  receiptsInfo,
  templateName,
  extraInfoForCertificate
}) => {
  debugger
  const s3response = await getUploadUrl({});

  if (s3response?.storage) {
    // call htmlToPdf API
    const response = await createPaymentReceipt({
      getPdf: false,
      receiptsInfo,
      uploadUrl: s3response.storage,
      templateName: templateName,
      ...extraInfoForCertificate,
    });

    if (response?.code === 200) {
      return s3response;
    }
    return s3response;
  }

  return null;
};

export const sendNotificationFn = async (payload) => {
  console.log(payload, 'payload');
  return await fetchAllPostPromisedData(
    `${endpoint.studentTransfer.sendNotif}/${payload?.details.psid}?s3Path=${payload?.s3Key}`,
    {},
    "post")
}
export const useNotificationLogic = ({
  details,
  fetchDetailsFn,
  getCreateReceiptTemplateData,
  sendNotificationFn,
  getUploadCertificateS3Key,
  buildFinalPayloadFn, // 💡 Injected custom payload generator
  defaultChannels = ["email"], // 💡 Configurable defaults
  onSuccess, // 💡 Optional success callback
  certificatePayloadData,
  dataEndpoint,
  templateName,
  extraInfoForCertificate
}) => {
  const [studentInfo, setStudentInfo] = useState(null);
  const [checked, setChecked] = useState(
    Object.fromEntries(defaultChannels.map((channel) => [channel, true]))
  );
  const [isNotifSent, setIsNotifSent] = useState(false);
  const [notifResponse, setNotifResponse] = useState("");
  const [loading, setLoading] = useState(false);

  const handleChange = (event) => {
    setChecked((prev) => ({
      ...prev,
      [event.target.name]: event.target.checked,
    }));
  };

  const getSelectedModes = () => {
    return Object.entries(checked)
      .filter(([, value]) => value)
      .map(([key]) => key.toUpperCase());
  };

  const handleSendNotification = async () => {

    try {
      setLoading(true);
      const certificateDetails = await fetchCertificateDetails(certificatePayloadData, dataEndpoint);
      const s3response = await getUploadCertificateS3Key({
        receiptsInfo: certificateDetails,
        templateName: templateName,
        extraInfoForCertificate
      });
      debugger
      if (s3response?.key) {
        const payload = buildFinalPayloadFn({
          selectedModes: getSelectedModes(),
          details: details,
          studentInfo,
          s3Key: s3response.key
        });

        const response = await sendNotificationFn(payload);

        if (response?.code === 200) {
          setNotifResponse(response);
          setIsNotifSent(true);
          onSuccess(response); // Optional callback
        }
      }
      // setIsNotifSent(true);
    }
    catch (err) {
      console.error(err)
    }
    finally {
      setLoading(false);
    }

  }
  // const handleSendNotification=()=>{

  // }

  return {
    studentInfo,
    checked,
    notifResponse,
    isNotifSent,
    loading,
    handleChange,
    handleSendNotification,
    setIsNotifSent,
  };
};


export const fetchCertificateDetails = async (payloadData = [], dataEndpoint) => {
  //  get receiptDetails
  const response = await fetchAllPostPromisedData(
    dataEndpoint,
    payloadData,
    "post"
  );

  if (response?.code == 200) return response.data;
  return null;
};
export const createPaymentReceipt = async ({
  getPdf,
  uploadUrl,
  receiptsInfo,
  templateName,
  transferReason,
  transferType
}) => {
  try {
    const reqObj = {
      templateName,
      uploadUrl,
      getPdf,
      templateData: getCreateReceiptTemplateData({ ...receiptsInfo, transferReason, transferType }),
    };

    return await fetchAllPostPromisedData(endpoint.createPdf, reqObj);
  } catch (err) {
    console.error(err);
  }
};
export const printReceipt = async ({ payloadData = [], getPdf = true, templateName = 'transferCertificate', dataEndpoint, transferReason, transferType }) => {
  // call fetchReceiptDetails API
  const certificateDetails = await fetchCertificateDetails(payloadData, dataEndpoint);

  if(certificateDetails){
  // call htmlToPdf API
  const response = await createPaymentReceipt({
    getPdf,
    receiptsInfo: certificateDetails,
    templateName: templateName,
    transferReason,
    transferType
  });

  if (response?.code === 200) {
    const pdfBuffer = response.pdfFile.data;

    const blob = new Blob([new Uint8Array(pdfBuffer)], {
      type: "application/pdf",
    });

    const url = URL.createObjectURL(blob);
    window.open(url);
  }
}
};
